import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { ApiService } from './custom-services/ApiService';
import { AuthService } from './service/auth.service';
import { DataService } from './service/data.service';

@Component({
    standalone: false,
  selector: "body",
  templateUrl: "./app.component.html"
})
export class AppComponent implements OnInit {

  constructor(private router: Router,
    private authService: AuthService,
    private toastr: ToastrService,
    private apiService: ApiService,
    private jwtHelper: JwtHelperService,
    private dataSource: DataService) { }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      else {
        let token = this.authService.getToken();
        if (token) {
          if (this.jwtHelper.isTokenExpired(token)) {

            let reqData = {
              "grantType": "refresh_token",
              "refreshToken": localStorage.getItem('refresh_token'),
              "rememberMe": true
            }
            this.apiService.post(environment.taxpayer_base_url + '/authenticationservice/v3/api/authenticate/taxpayer', reqData)
              .subscribe(result => {
                if (result.success === true) {
                  localStorage.removeItem('token');
                  localStorage.removeItem('refresh_token');

                  let token = result.replyMessage['body']['id_token'];
                  let refreshToken = result.replyMessage['body']['refresh_token'];
                  localStorage.setItem('token', token);
                  localStorage.setItem('refresh_token', refreshToken);

                  let tokenInfo = this.jwtHelper.decodeToken(token)['claims'];
                  let userName = tokenInfo['userFullName'];
                  localStorage.setItem('name', userName);
                } else {
                  localStorage.clear();
                  this.router.navigate(['/auth/sign-in']);
                }
              },
                error => {
                  localStorage.clear();
                  this.router.navigate(['/auth/sign-in']);
                });

            //#endregion
          }
          else {
            // token valid
          }
        }
        //#endregion
      }
      window.scrollTo(0, 0);
    });

    //logout user from all tabs
    window.addEventListener('storage', (event) => {
      if (event.storageArea == localStorage) {
        let token = this.authService.getToken();
        if (token == undefined) {
          this.router.navigate(["/auth/sign-in"]);
        } else if(event.key === 'token' && event.oldValue !== event.newValue) {
          location.reload();
        }

        // Reload if CURRENT_ASSESSMENT_YEAR changes
        if (event.key === 'CURRENT_ASSESSMENT_YEAR') {
          // Only reload if the value actually changed
          if (event.oldValue !== event.newValue) {
            location.reload();
          }
        }
      }
    });
  }
}
